module.exports = __webpack_public_path__ + "assets/img/11_939.a9931faf.jpg";